module.exports = __webpack_public_path__ + "static/img/logo.c37b5950.png";